<template>
  <section class="results" id="resultsDiv">
    <h2 class="results__title">Başvuru Yapabileceğiniz Programlar</h2>
    <p class="results__subtitle">
      Fakülte veya yüksekokul mezunuysanız aşağıda listelenen tezsiz yüksek
      lisans programlarına başvurabilirsiniz.
    </p>

    <template v-if="programs.length > 0">
      <p v-if="!isNewApplicationOpen" class="alert-pastdata">
        <strong>Önemli not:</strong> Lisansüstü öğrenci alım tarihi henüz
        belirlenmemiştir. Aşağıdaki program bilgileri geçmiş dönemlere ait
        verilerdir; yeni alımlar açıklandığında
        <strong>ilgili şartlar değişiklik gösterebilir</strong>. Alımlardan
        haberdar olmak için
        <a data-toggle="modal" data-target="#newsletter">bültene kayıt olun</a>.
      </p>

      <div class="results-card">
        <table class="results-table">
          <thead>
            <tr>
              <th class="text-left">Program</th>
              <th class="text-left">Başvuru Dönemi</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(program, index) in programs" :key="index">
              <td class="cell-program" data-label="Program">
                {{ program.name }}
              </td>
              <td class="cell-dates" data-label="Başvuru Dönemi">
                <span v-if="isNewApplicationOpen"
                  >{{ program.start_date }} – {{ program.end_date }}</span
                >
                <span v-else>—</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </template>

    <p v-else class="alert-pastdata">
      Şu anda açık bir tezsiz yüksek lisans alım ilanı bulunmamaktadır.
    </p>

    <p v-if="announcementUrl" class="text-center" style="margin-top: 20px">
      <a
        :href="announcementUrl"
        target="_blank"
        rel="noopener"
        class="btn btn-primary btn-search"
        >Ayrıntılı Bilgi ve Başvuru</a
      >
    </p>
  </section>
</template>

<script>
export default {
  name: "NoThesisProgramResult",
  props: {
    programs: {
      type: Array,
      default: () => [],
    },
    isNewApplicationOpen: {
      type: Boolean,
      default: false,
    },
    announcementUrl: {
      type: String,
      default: "",
    },
  },
};
</script>

<style scoped></style>
